// # Maintenance Signup Page Component
import React from 'react';
import './signup_mock.css';
import AuthHeader from '../components/AuthHeader';
import { FaTools } from 'react-icons/fa';
import signupImage from '../../aneo_media/signup/signup.jpg';

function SignupMock() {
  return (
    <div>
      <AuthHeader />
      <div 
        className="sgnp_mock_signup-container"
        style={{ '--signup-background-image': `url(${signupImage})` }}
      >
        <div className="sgnp_mock_signup-image-section" />
        <div className="sgnp_mock_maintenance-section">
          <div className="sgnp_mock_maintenance-icon">
            <FaTools />
          </div>
          <h2 className="sgnp_mock_maintenance-title">Under Maintenance</h2>
          <p className="sgnp_mock_maintenance-message">
            We're currently enhancing our registration system to provide you with a better experience.
            The sign-up functionality will be available soon.
          </p>
          <p className="sgnp_mock_maintenance-message">
            Thank you for your patience and understanding.
          </p>
          <div className="sgnp_mock_maintenance-contact">
            Questions? Contact us at{' '}
            <a href="mailto:customer-service@wearetempu.com">customer-service@wearetempu.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupMock;
